<template>
    <div class="price-range">
        <van-grid :column-num="3">
            <van-grid-item v-for="(itm, idx) in data" :key="idx" :text="itm.text" @click="pick(itm)" class="{ curItem.id==itm.id: 'sel' }" />
        </van-grid>
    </div>
</template>

<script>
import { 
    Grid,
    GridItem,
    Image,
    Row,
    Col,
    Icon, 
    Loading, 
    List
} from 'vant'

export default {
    name: 'PriceRange',
    components: {
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col
    },
    data() {
        return {
            data: [
                { id :0, text:'10万以下'},
                { id :1, text:'10-20万'},
                { id :2, text:'20-30万'},
                { id :3, text:'30-40万'},
                { id :4, text:'40-50万'},
                { id :5, text:'50万以上'},
            ], // 所有类别数据
            curItem: {id: null, text: null}
        }
    },
    methods: {
        pick(obj) {
            this.curItem = obj
            this.$emit('pick', obj)
        },
    }
}
</script>

<style lang="less" scoped>
    .price-range {
        .sel {
            background-color: #409EFF;
        }
        .unsel {
            background-color: #c2d2e2;
        }
    }
</style>
